<template>
  <el-form
    ref="formInfo"
    :model="form"
    :rules="rules"
    label-width="auto"
    :label-position="labelPosition"
  >

    <h2 class="form-title">Contact Info</h2>

    <el-form-item label="Organization Name" prop="CUST_NAME_EN" class="skyblueItem">
      <el-input v-model="form.CUST_NAME_EN"></el-input>
    </el-form-item>

    <el-form-item label="Organization Name(Chinese)" prop="CUST_NAME_CH" class="skyblueItem">
      <el-input v-model="form.CUST_NAME_CH"></el-input>
    </el-form-item>
    
    <el-form-item label="Contact Person" prop="CONTACT_NAME" class="skyblueItem">
      <el-input v-model="form.CONTACT_NAME"></el-input>
    </el-form-item>

    <el-form-item label="Contact Email" prop="EMAIL" class="skyblueItem">
      <el-input v-model="form.EMAIL"></el-input>
    </el-form-item>

    <el-form-item label="Contact Phone" prop="CELL_PHONE" class="skyblueItem">
      <el-input v-model="form.CELL_PHONE"></el-input>
    </el-form-item>

    <h2 class="form-title">Event</h2>

    <el-form
      v-for="(event, eventIndex) in form.events"
      :key="eventIndex"
      :ref="`formEvent${eventIndex}`"
      :model="event"
      :rules="rules"
      label-width="auto"
      :label-position="labelPosition"
    >
      <div class="form-event">
        <span v-if="form.events.length > 1">
          Event {{ eventIndex + 1 }}
        </span>

        <el-button
          type="danger"
          v-if="form.events.length > 1"
          size="mini"
          @click="removeEvent(eventIndex)"
        >
          移除
        </el-button>
      </div>

      <!-- <p>Program</p> -->

      <el-form-item label="Event Topic" prop="EVENT_NAME" class="skyblueItem">
        <el-input v-model="event.EVENT_NAME"></el-input>
      </el-form-item>

      <el-form-item label="Event Type" prop="EVENT_TYPE" class="skyblueItem">
        <el-select v-model="event.EVENT_TYPE" placeholder="Please select">
          <el-option
            v-for="(type, index) in options.eventTypeItems"
            :key="index"
            :label="type.labelEn"
            :value="type.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Program Length(Minutes)" prop="PROGRAM_LEN" class="skyblueItem">
        <el-input-number
          v-model="event.PROGRAM_LEN"
          :min="10"
          :max="1440"
          controls-position="right">
        </el-input-number>
      </el-form-item>

      <el-form-item label="Audience Type" prop="AUDIENCE_TYPE" class="skyblueItem">
        <el-select v-model="event.AUDIENCE_TYPE" placeholder="Please select">
          <el-option
            v-for="(type, index) in options.audienceTypeItems"
            :key="index"
            :label="type.labelEn"
            :value="type.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Estimated Attendance" prop="CNT_AUDIENCE" class="skyblueItem">
        <el-input-number
          v-model="event.CNT_AUDIENCE"
          :min="10"
          :step="10"
          controls-position="right">
        </el-input-number>
      </el-form-item>

      <!-- <p>Location</p> -->

      <el-form-item label="Region/Country" prop="COUNTRY_ID" class="skyblueItem">
        <el-select
          v-model="event.COUNTRY_ID"
          @change="updateCountry(eventIndex, $event)"
          default-first-option
          filterable
          placeholder="Please select">
          <el-option
            v-for="(item, index) in options.countries"
            :key="index"
            :label="item.labelEn"
            :value="item.value">
            <span style="float: left; margin-right: 20px">{{ item.labelEn }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span>
          </el-option>
        </el-select>
      </el-form-item>

      <template v-if="event.COUNTRY_ID === 'TW'">
        <el-form-item label="City" prop="CITY" class="skyblueItem">
          <el-select
            v-model="event.CITY"
            @change="updateTwCity(eventIndex, $event)"
            placeholder="Please select">
            <el-option
              v-for="(city, index) in options.twCities"
              :key="index"
              :label="city.labelEn"
              :value="city.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Area" prop="AREA" class="skyblueItem">
          <el-select
            v-model="event.AREA"
            @change="updateTwArea(eventIndex, $event)"
            placeholder="Please select">
            <el-option
              v-for="(area, index) in options.twAreas[event.CITY]"
              :key="index"
              :label="area.labelEn"
              :value="area.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="Postcode" prop="ZIP" class="skyblueItem">
          <el-input v-model="event.ZIP" disabled></el-input>
        </el-form-item>
      </template>

      <template v-else>
        <el-form-item label="State" prop="STATE" class="skyblueItem">
          <el-input v-model="event.STATE"></el-input>
        </el-form-item>

        <el-form-item label="City" prop="CITY" class="skyblueItem">
          <el-input v-model="event.CITY"></el-input>
        </el-form-item>

        <el-form-item label="Postcode" prop="ZIP" class="skyblueItem">
          <el-input v-model="event.ZIP"></el-input>
        </el-form-item>
      </template>

      <el-form-item label="Address" prop="ADDRESS" class="skyblueItem">
        <el-input v-model="event.ADDRESS"></el-input>
      </el-form-item>

      <!-- <p>Date</p> -->

      <el-form-item label="Preferred Date (1st)" prop="EXPECT_DATE_1" class="skyblueItem">
        <el-date-picker
          v-model="event.EXPECT_DATE_1"
          type="datetime"
	  :picker-options="pickerOptions"
          format="yyyy/MM/dd HH:mm"
          placeholder="Please select">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="Preferred Date (2nd)" prop="EXPECT_DATE_2" class="skyblueItem">
        <el-date-picker
          v-model="event.EXPECT_DATE_2"
          format="yyyy/MM/dd HH:mm"
          type="datetime"
	  :picker-options="pickerOptions"
          placeholder="Please select">
        </el-date-picker>
      </el-form-item>

      <el-form-item label="Preferred Date (3rd)" prop="EXPECT_DATE_3" class="skyblueItem">
        <el-date-picker
          v-model="event.EXPECT_DATE_3"
          type="datetime"
	  :picker-options="pickerOptions"
          format="yyyy/MM/dd HH:mm"
          placeholder="Please select">
        </el-date-picker>
      </el-form-item>

      <!-- <p>Place</p> -->

      <el-form-item label="Changing Room" prop="LOUNGE_Y_N" class="skyblueItem">
        <!--div>Is changing room/ rest area available?</div!-->
        <el-radio-group v-model="event.LOUNGE_Y_N" size="medium">
          <el-radio label="Y" border>Yes</el-radio>
          <el-radio label="N" border>No</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Sound Equipment" prop="SOUND_SYSTEM_Y_N" class="skyblueItem">
        <!--div>Is sound equipment available?</div!-->
        <el-radio-group v-model="event.SOUND_SYSTEM_Y_N" size="medium">
          <el-radio label="Y" border>Yes</el-radio>
          <el-radio label="N" border>No</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Meals" prop="MEAL_Y_N" class="skyblueItem">
        <!--div>Are meals provided?</div!-->
        <el-radio-group v-model="event.MEAL_Y_N" size="medium">
          <el-radio label="Y" border>Yes</el-radio>
          <el-radio label="N" border>No</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Sell Products" prop="PROD_SELL_Y_N" class="skyblueItem">
        <!--div>Can we bring our products to sell?</div!-->
        <el-radio-group v-model="event.PROD_SELL_Y_N" size="medium">
          <el-radio label="Y" border>Yes</el-radio>
          <el-radio label="N" border>No</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Invoice" prop="RCPT_Y_N" class="skyblueItem">
        <!-- <div></div> -->
        <el-radio-group v-model="event.RCPT_Y_N" size="medium">
          <el-radio label="Y" border>Yes</el-radio>
          <el-radio label="N" border>No</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Parking Space" prop="PARKING_Y_N" class="skyblueItem">
        <!--div>Is parking available?</div!-->
        <el-radio-group v-model="event.PARKING_Y_N" size="medium">
          <el-radio label="Y" border>Yes</el-radio>
          <el-radio label="N" border>No</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="Tranportation Provided" prop="TRANS_PROVIDED" class="skyblueItem">
        <el-select
          v-model="event.TRANS_PROVIDED"
          placeholder="Please select">
          <el-option
            v-for="(item, index) in options.transportationItems"
            :key="index"
            :label="item.labelEn"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Event Place" prop="EVENT_PLACE" class="skyblueItem">
        <el-input v-model="event.EVENT_PLACE" placeholder="please input Chapel or Room 301"></el-input>
      </el-form-item>

    </el-form>

    <hr>

    <div class="form-add-wrapper">
      <el-button type="primary" @click="addEvent">Add Event</el-button>
    </div>

    <el-form-item label="Remarks" class="skyblueItem">
      <el-input
        type="textarea"
        :rows="3"
        placeholder="Please input"
        v-model="form.REMARK">
      </el-input>
    </el-form-item>

    <el-form-item>
      <el-button type="primary" @click="submit">Submit</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
import { event } from '@/helpers/event'
//import { event } from '@/helpers/event-test-eng'
import { countries } from '@/helpers/countryRegions'
import { cities, districts } from '@/helpers/twRegions'
import { eventTypeItems, audienceTypeItems, transportationItems } from '@/helpers/selectOptions'
import { rulesEn } from '@/helpers/formRules'
import { cloneDeep } from 'lodash'

export default {
  name: '',

  data() {
    return {

      // 活動場次版型
      event: cloneDeep(event),

      // 驗證規則
      rules: rulesEn,

      // 表單
      form: {
        CUST_NAME_EN: '',
        CUST_NAME_CH: '',
        CONTACT_NAME: '',
        EMAIL: '',
        CELL_PHONE: '',
        REMARK: '',

        events: [ event ]
      },

      pickerOptions: {
        // disabledDate是一个函数,参数是当前选中的日期值,这个函数需要返回一个Boolean值,
        disabledDate: (time) => {
          // 如果函数处理比较简单,可以直接在这里写逻辑方法
          // return time.getTime() < Date.now()  - 8.64e7

          // 如果函数里处理的数据比较麻烦,也可以单独放在一个函数里,避免data数据太臃肿
          return this.dealDisabledDate(time)
        }
      }, // 日期设置对象

      // 表單選項
      options: {
        countries,
        twCities: cities,
        twAreas: districts,
        eventTypeItems,
	audienceTypeItems,
        transportationItems
      },

      labelPosition: 'right'
    }
  },

  methods: {

    checkLabelPosition() {
      let width = window.innerWidth

      if (width < 768) {
        this.labelPosition = 'top'
      } else {
        this.labelPosition = 'right'
      }
    },

    // 单独处理时间的函数
    dealDisabledDate (time) {
      // time.getTime是把选中的时间转化成自1970年1月1日 00:00:00 UTC到当前时间的毫秒数
      // Date.now()是把今天的时间转化成自1970年1月1日 00:00:00 UTC到当前时间的毫秒数,这样比较好比较
      // return的值,true是不可以操作选择,false可以操作选择,比如下面这个判断就只能选择今天之后的时间
      return time.getTime() < Date.now()

      // 这里减8.64e7的作用是,让今天的日期可以选择,如果不减的话,今天的日期就不可以选择,判断中写<= 也是没用的,一天的毫秒数就是8.64e7
      // return time.getTime() <= Date.now()
      // return time.getTime() < Date.now() - 8.64e7
    },

    // 更新區域/國家
    updateCountry(index, event) {
      if (event === 'TW') {
        let city = this.options.twCities[0].value // 台北市

        this.form.events[index].CITY = city
        this.updateTwCity(index, city)
      } else {
        this.form.events[index].STATE = ''
        this.form.events[index].CITY = ''
        this.form.events[index].ZIP = ''
      }
    },

    // 更新台灣城市
    updateTwCity(index, event) {
      // index 是當前的 event 位於 events 陣列的索引值
      // event 是下拉式選單的值，例如：台北市

      // 更新區域
      this.form.events[index].AREA = this.options.twAreas[event][0].value
      // 更新郵遞區號
      this.form.events[index].ZIP = this.options.twAreas[event][0].postcode
    },

    // 更新台灣區域
    updateTwArea(index, event) {
      let city = this.form.events[index].CITY

      let district = this.options.twAreas[city].filter(item => {
        return item.value === event
      })[0]

      this.form.events[index].ZIP = district.postcode
    },

    // 新增活動
    addEvent() {
      let event = cloneDeep(this.event)

      return this.form.events.push(event)
    },

    // 移除活動
    removeEvent(index) {
      return this.form.events.splice(index, 1)
    },

    submit() {
      let pass = 1

      this.$refs.formInfo.validate(valid => {
        if (! valid)
          pass = pass * 0
      })

      this.form.events.forEach((event, index) => {
        this.$refs[`formEvent${index}`][0].validate(valid => {
          if (! valid)
            pass = pass * 0
        })
      })

      console.log(pass)

      if (pass) {
        console.log('驗證成功');
	this.form.LANGUAGE="ENG";
	console.log("form = "+qs.stringify(this.form));
	//送出儲存申請
	axios.post('/api/createEvent.php', qs.stringify(this.form))
	     .then(function (response) {
		console.log(response);
		console.log("Send notice email.");
		console.log(response.data);
		console.log('result = '+response.data.result);
		//發送通知信
		
		axios.post('/api/sendNotice.php', qs.stringify(response.data))
                     .then(function (response) { 
		        console.log(response.data);
		       })
		     .catch(function (error) {
			console.log(error);
		       });
		
			
		})
		
	     .catch(function (error) {
	        console.log(error);
		});
        
	this.$router.push({path: '/finish'});
      } else {
        console.log('驗證失敗');
      }
    }
  },

  mounted () {
    this.checkLabelPosition()
  }
}
</script>
<style>

.redItem .el-form-item__label{
        color: red;
    }
.blueItem .el-form-item__label{
        color: blue;
    }
.skyblueItem .el-form-item__label{
        color: skyblue;
    }
</style>
<style lang="sass">
.form-title
  font-size: 14px
  font-weight: 444
  color: #999
  text-align: right

.form-event
  text-align: center
  margin: 25px 0

  button
    margin-left: 10px

input.el-input__inner,
textarea.el-textarea__inner
  border-color: #fff
  background-color: transparent
  color: #FFFFFF

.el-select,
.el-input-number,
.el-date-editor
  width: 100% !important
</style>
